module.exports = __webpack_public_path__ + "static/media/Checkout.5ade4d7a.png";